import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import callApi from 'helpers/apiCaller';
import config from 'common/config';
import {
  MenuStudent,
  MenuTeacher,
  MenuTeacherEssay
} from '../../components/Sidebar/components/';
import getCachedData from 'helpers/getStoreCache';
import Cookies from 'universal-cookie';
import { Redirect, useLocation } from 'react-router-dom';

const Sidebar = (props) => {
  var cookies = new Cookies();
  var accessToken = cookies.get('access_token');
  if (accessToken == undefined) {
    //login gv
    accessToken = window.localStorage.getItem('AccessToken');
  }
  if (accessToken == undefined) {
    // hs
    accessToken = '';
  }
  var header = { authorization: accessToken };

  const userStore = cookies.get('user_store');
  const location = useLocation();

  const [groupId, setGroupId] = useState(() => {
    if (userStore?.roles != null) {
      if (userStore.roles.admin) {
        return 7;
      } else if (userStore.roles.school) {
        return 5;
      } else if (userStore.roles.teacher) {
        return 3; // gv
      } else if (userStore.roles.student) {
        return 1; // student
      }
    }
    return 1;
  });

  useEffect(() => {
    (async () => {
      const handleClick = (e) => {
        e.preventDefault();
        $('body').toggleClass('menu-active');
      };

      // Thêm sự kiện click
      $('.menu-toggle').on('click', handleClick);

      // Cleanup để đảm bảo sự kiện chỉ thêm một lần
      return () => {
        $('.menu-toggle').off('click', handleClick);
      };
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await getCachedData('user_store', '/').then(async (response) => {
        if (response != undefined && response != false) {
          if (userStore != undefined && userStore.roles != undefined) {
            if (
              userStore.roles.school != undefined &&
              userStore.roles.school == true
            ) {
              setGroupId(5); // school
            } else if (
              userStore.roles.teacher != undefined &&
              userStore.roles.teacher == true
            ) {
              setGroupId(3); // gv
            } else if (
              userStore.roles.student != undefined &&
              userStore.roles.student == true
            ) {
              setGroupId(1); // student
            }
          }
        } else {
          const body1 = {};
          // get user
          const url = config.getRootURL() + '/gd/v3/user_infos';
          await callApi(url, 'GET', body1, header).then((response) => {
            if (response == false) {
              config.hideLoader();
              return false;
            }
            if (response != undefined) {
              var userStore = response.data.data.user;
              if (userStore != undefined && userStore.roles != undefined) {
                if (
                  userStore.roles.school != undefined &&
                  userStore.roles.school == true
                ) {
                  setGroupId(5); // school
                } else if (
                  userStore.roles.teacher != undefined &&
                  userStore.roles.teacher == true
                ) {
                  setGroupId(3); // gv
                } else if (
                  userStore.roles.student != undefined &&
                  userStore.roles.student == true
                ) {
                  setGroupId(1); // student
                }
              }
              //response.data.data.user.id = 0;
              cookies.set(
                'user_store',
                JSON.stringify(response.data.data.user).replace(
                  /</g,
                  '\\u003c'
                ),
                { path: '/' }
              );
              config.AddDataIntoCache(
                'user_store',
                '/',
                JSON.stringify(response.data.data.user)
              );
              config.AddDataIntoCache('is_logged', '/', true);
              window.localStorage.setItem(
                'course_id',
                $('#top_course_id').val()
              );
            }
          });
        }
      });

      // Remove existing event handlers to prevent double binding
      $('.sidebar-menu .has-sub > a').off('click.sidebar');
      $('.menu-toggle').off('click.sidebar');
      $('.bg-overlay').off('click.sidebar');

      // Add event handlers with namespace for easy removal
      $('.sidebar-menu .has-sub > a').on('click.sidebar', function (e) {
        e.preventDefault();
        $('.sidebar-menu .sidebar-sub').slideUp(200);
        if ($(this).parent().hasClass('active')) {
          $('.sidebar-menu .sidebar-item').removeClass('active');
          $(this).parent().removeClass('active');
        } else {
          $('.sidebar-menu .sidebar-item').removeClass('active');
          $(this).next('.sidebar-menu .sidebar-sub').slideDown(200);
          $(this).parent().addClass('active');
        }
      });

      $('.menu-toggle').on('click.sidebar', function (e) {
        e.preventDefault();
        $('.sidebar-menu li')
          .siblings()
          .each(function () {
            $(this).removeClass('active');
            $('.sidebar-menu .sidebar-sub').slideUp(1);
          });
      });

      $('.bg-overlay').on('click.sidebar', function () {
        $('body').removeClass('menu-active');
        $('.video-sidebar').removeClass('active');
        $(this).removeClass('block');
      });

      // $("ul> li").on("click", function() {
      //   $(this).addClass("active");
      //   $(this).addClass("curent");
      //   $("#subquanly").show();
      // });

      if (
        location.pathname == '/thi' ||
        location.pathname == '/thi-thpt-2025' ||
        location.pathname == '/thi-thu' ||
        location.pathname == '/thi-thu-thpt-qg'
      ) {
        // Ensure sidebar is closed on exam pages (especially on mobile)
        $('body').removeClass('menu-active');
        $('#phongthitructuyen').removeClass('active');
      } else {
        // $("ul> li").removeClass("active");
        $('#subquanly').hide();
      }

      $('#phongthitructuyen').removeClass('active');
      $('#dethicanlam').removeClass('active');
      $('#lichsuthi').removeClass('active');
      //  student
      if (location.pathname == '/phong-thi-truc-tuyen') {
        $('#phongthitructuyen').addClass('active');
      } else if (location.pathname == '/thi-thu') {
        $('#thithu').addClass('active');
      } else if (location.pathname == '/de-thi-can-lam') {
        $('#phongthitructuyen').removeClass('active');
        $('#dethicanlam').addClass('active');
      } else if (location.pathname == '/lich-su-thi') {
        $('#phongthitructuyen').removeClass('active');
        $('#lichsuthi').addClass('active');
      } else if (location.pathname == '/bao-cao-hoc-tap') {
        $('#baocaohoctap').addClass('active');
      } else if (location.pathname == '/lop-hoc-them') {
        $('#lophocthem').addClass('active');
      } else if (location.pathname == '/lop-hoc-khac') {
        $('#lophockhac').addClass('active');
      } else if (location.pathname == '/tao-nhom-hoc-tap') {
        $('#taonhomhoctap').addClass('active');
      } else if (location.pathname == '/thong-tin-tuyen-sinh') {
        $('#thongtintuyensinh').addClass('active');
      } else if (location.pathname == '/thu-vien') {
        $('#thuvien').addClass('active');
      } else if (location.pathname == '/tai-lieu-huong-dan') {
        $('#phongthitructuyen').removeClass('active');
        $('#tailieu').addClass('active');
      }
      // else if(location.pathname == "/de-thi-can-lam"){
      //   $("#phongthitructuyen").addClass('active');
      // }
      // else if(location.pathname == "/lich-su-thi"){ // thuoc phong thi truc tuyen
      //   $("#phongthitructuyen").addClass('active');
      // }
      // teacher
      else if (
        location.pathname == '/khoi' ||
        location.pathname == '/lop' ||
        location.pathname == '/chi-tiet-lop'
      ) {
        $('#quanly').addClass('active');
        $('#danhsachhocsinh a').addClass('curent');
        $('#subquanly').show();
      } else if (
        location.pathname == '/khoi-tao-phong-thi' ||
        location.pathname == '/step-them-hoc-sinh' ||
        //location.pathname == "/step-them-hoc-sinh-phong" ||
        //location.pathname == "/step-upload-de-thi" ||
        location.pathname == '/step-chuyen-de'
      ) {
        $('#tochucthitructuyen').addClass('active');
      } else if (location.pathname == '/xu-ly-tinh-huong-thi') {
        $('#xulytinhhuongthi').addClass('active');
      } else if (
        location.pathname == '/quan-ly-diem' ||
        location.pathname == '/diem-danh-sach' ||
        location.pathname == '/chi-tiet-diem'
      ) {
        $('#quanly').addClass('active');
        $('#quanlydiem a').addClass('curent');
        $('#subquanly').show();
      } else if (location.pathname == '/quan-ly-ky-thi') {
        $('#quanly').addClass('active');
        $('#quanlykythi a').addClass('curent');
        $('#subquanly').show();
      } else if (location.pathname == '/quan-ly-mon-hoc') {
        $('#quanly').addClass('active');
        $('#quanlymonhoc a').addClass('curent');
        $('#subquanly').show();
      }
      // else if(location.pathname == "/de-thi"){
      //   $("#quanlydethi").addClass('active');
      // }
      // else if(location.pathname == "/de-thi")
      // {
      //   $("#quanlydethi").addClass('active');
      //   $("#danhsachdethi a").addClass('curent');
      //   $("#subquanlydethi").show();
      // }
      else if (
        location.pathname == '/de-thi' ||
        location.pathname == '/danh-sach-cau-hoi'
      ) {
        $('#quanlydethi').addClass('active');
        $('#danhsachdethi a').addClass('curent');
        $('#subquanlydethi').show();
      } else if (location.pathname == '/de-thi-da-chuyen') {
        $('#quanlydethi').addClass('active');
        $('#danhsachdethidachuyen a').addClass('curent');
        $('#subquanlydethi').show();
      } else if (location.pathname == '/step-upload-de-thi') {
        // $("#quanlydethi").addClass('active');
        // $("#uploaddethi a").addClass('curent');
        // $("#subquanlydethi").show();
        $('#quanlydethithptqg').addClass('active');
        $('#uploaddethi a').addClass('curent');
        $('#subquanlydethithptqg').show();
      } else if (location.pathname == '/step-them-hoc-sinh-phong') {
        $('#quanly').addClass('active');
        $('#danhsachhocsinhphong a').addClass('curent');
        $('#subquanly').show();
      }
      // else if(location.pathname == "/cham-diem-bai-thi"){
      //   $("#quanlythituluan").addClass('active');
      //   $("#chamdiembaithi a").addClass('curent');
      //   $("#subquanlythituluan").show();
      // }
      else if (
        location.pathname == '/danh-sach-bai-thi-tu-luan' ||
        location.pathname == '/danh-sach-de-thi-tu-luan' ||
        location.pathname == '/danh-sach-chua-cham-diem' ||
        location.pathname == '/danh-sach-da-cham-diem'
      ) {
        $('#quanlythituluan').addClass('active');
        $('#danhsachbaithituluan a').addClass('curent');
        $('#subquanlythituluan').show();
      } else if (
        location.pathname == '/danh-sach-bai-thi-tu-luan-lop' ||
        location.pathname == '/danh-sach-chua-cham-diem-lop' ||
        location.pathname == '/danh-sach-da-cham-diem-lop'
      ) {
        $('#quanlythituluan').addClass('active');
        $('#danhsachbaithituluanlop a').addClass('curent');
        $('#subquanlythituluan').show();
      } else if (location.pathname == '/danh-sach-giao-vien') {
        $('#quanly').addClass('active');
        $('#danhsachgiaovien a').addClass('curent');
        $('#subquanly').show();
      } else if (location.pathname == '/danh-sach-giao-vien-quan-ly-lop') {
        $('#quanly').addClass('active');
        $('#danhsachgiaovienquanlylop a').addClass('curent');
        $('#subquanly').show();
      } else if (location.pathname == '/tao-noi-dung-h5p') {
        $('#quanlyh5p').addClass('active');
        $('#taomoih5p a').addClass('curent');
        $('#subquanlyh5p').show();
      } else if (location.pathname == '/danh-sach-noi-dung-h5p') {
        $('#quanlyh5p').addClass('active');
        $('#danhsachnoidungh5p a').addClass('curent');
        $('#subquanlyh5p').show();
      } else if (location.pathname == '/danh-sach-diem-h5p') {
        $('#quanlyh5p').addClass('active');
        $('#danhsachdiemh5p a').addClass('curent');
        $('#subquanlyh5p').show();
      } else if (location.pathname == '/upload-tai-lieu') {
        $('#quanlytailieu').addClass('active');
        $('#uploadtailieu a').addClass('curent');
        $('#subquanlytailieu').show();
      } else if (location.pathname == '/danh-sach-tai-lieu') {
        $('#quanlytailieu').addClass('active');
        $('#danhsachtailieu a').addClass('curent');
        $('#subquanlytailieu').show();
      } else if (location.pathname == '/step-upload-de-thi-thptqg') {
        $('#quanlydethithptqg').addClass('active');
        $('#uploaddethithptqg a').addClass('curent');
        $('#subquanlydethithptqg').show();
      } else if (
        location.pathname == '/xu-ly-phieu-tra-loi' ||
        location.pathname.startsWith('/xu-ly-phieu-tra-loi/')
      ) {
        $('#quanlyphieutraloi').addClass('active');
        $('#xulyphieutraloi a').addClass('curent');
        $('#subquanlyphieutraloi').show();
      } else if (
        location.pathname == '/thong-ke' ||
        location.pathname.startsWith('/thong-ke/')
      ) {
        $('#quanlyphieutraloi').addClass('active');
        $('#thongke a').addClass('curent');
        $('#subquanlyphieutraloi').show();
      } else if (location.pathname == '/danh-sach-mau-phieu-cham') {
        $('#quanlyphieutraloi').addClass('active');
        $('#mauphieucham a').addClass('curent');
        $('#subquanlyphieutraloi').show();
      } else if (location.pathname == '/quan-ly-phieu-tra-loi') {
        $('#quanlyphieutraloi').addClass('active');
        $('#quanlyphieutraloilist a').addClass('curent');
        $('#subquanlyphieutraloi').show();
      } else if (location.pathname == '/system-lms360') {
        $('#systemlms360').addClass('active');
      }
    })();

    // Cleanup function to remove event handlers when component unmounts
    return () => {
      $('.sidebar-menu .has-sub > a').off('click.sidebar');
      $('.menu-toggle').off('click.sidebar');
      $('.bg-overlay').off('click.sidebar');
    };
  }, [location.pathname]);

  return groupId === 5 ? (
    <MenuTeacher />
  ) : groupId === 3 ? (
    <MenuTeacherEssay />
  ) : groupId === 1 ? (
    <MenuStudent />
  ) : groupId === 7 ? (
    <Redirect to="/not-support-role" />
  ) : (
    ''
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  variant: PropTypes.string
};

export default Sidebar;
